import store from '@/store/store';
import {
  clGuardarDocumentosRecurrentes,
  clListarDocumentosRecurrentes,
  clObtenerDocumentoRecurrente
} from '@/febos/servicios/api/dte.api';
import { fileBinnacle } from '@/febos/servicios/api/portafolio.api';

export default {
  async openNewBilling({ commit }, { id = 'new' } = {}) {
    commit('SET_ACTUAL_BILLING', { id });
    commit('SET_NEW_BILLING', { id });
    store.dispatch('Modals/showModals', 'newBilling');
  },

  async openEditBilling({ commit }, { id } = {}) {
    commit('SET_ACTUAL_BILLING', { id });
    commit('SET_LOADING', true);
    try {
      const { data } = await clObtenerDocumentoRecurrente({ id });
      const { documento } = data;
      commit('SET_BILLING_INFORMATION', documento);
      commit('SET_LOADING', false);
      store.dispatch('Modals/showModals', 'newBilling');
    } catch (e) {
      console.error(e);
      commit('SET_LOADING', false);
    }
  },
  async openPreviewBilling({ commit }, { id } = {}) {
    commit('SET_ACTUAL_BILLING', { id });
    try {
      const { data } = await clObtenerDocumentoRecurrente({
        id,
        pdf: 'Y'
      });
      const { linkPDF } = data;
      window.open(linkPDF, '_blank');
    } catch (e) {
      console.error(e);
    }
  },
  updateActualData({ commit }, data) {
    commit('SET_DATA', data);
  },
  async fetchBillings({ commit }, {
    filter,
    page,
    limit,
    order
  }) {
    commit('SET_LOADING', true);
    try {
      const response = await clListarDocumentosRecurrentes({
        filter,
        page,
        limit,
        order
      });
      const {
        documentos: billings,
        totalPaginas,
        totalElementos
      } = response.data;
      commit('SET_PAGINATION', {
        items: totalElementos,
        pages: totalPaginas
      });
      commit('SET_LIST', billings);
      commit('SET_ACTUAL_FILTER', {
        filter,
        order,
        limit,
        page
      });
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async saveBilling({
    commit,
    state,
    dispatch
  }, references) {
    commit('SET_SAVING', true);
    try {
      const body = {
        ...state.billings,
        personalizados: Object.values(state.billings.personalizados || {}),
        referencias: references.map((reference, index) => ({
          linea: index + 1,
          ...reference
        }))
      };
      await clGuardarDocumentosRecurrentes({
        ...body,
        ...(state.actual !== 'new' && { id: state.actual })
      });
      commit('CLEAR_BILLING');
      setTimeout(() => {
        store.dispatch('Modals/closeModal', 'newBilling');
        dispatch('fetchBillings', {
          ...state.actualFilter,
          ...(state.actual !== 'new' && { page: 1 })
        });
      }, 1000);
    } finally {
      commit('SET_SAVING', false);
    }
  },
  async getBinnacle({ commit }, {
    febosId,
    filas = 200,
    pagina = 1
  }) {
    commit('SET_LOADING', true);
    commit('SET_BINNACLE', []);
    try {
      const response = await fileBinnacle({
        documentoId: febosId,
        filas,
        pagina
      });
      commit('SET_BINNACLE', response.data.bitacora);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  selectFile({ commit }, file) {
    commit('SET_BILLING_INFORMATION', file);
  }
};
